import React, { useRef, useState, useEffect } from "react";
import { fetchLogoOnce } from '../../utils/logoService';

function ChatTongole() {
  let hideChat = false;
  try {
    hideChat = window.location.hostname.toLowerCase().includes('xbet50');
  } catch (e) { /* ignore */ }

  const chatRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [logo, setLogo] = useState("");
  const [whatsappLink, setWhatsappLink] = useState(null);
  const [dragDistance, setDragDistance] = useState(0);
  const [position, setPosition] = useState({
    x: window.innerWidth - 70,
    y: window.innerHeight - 150,
  });
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [show, setShow] = useState(null);

  // Fetch logo via singleton service (no duplicate network request)
  useEffect(() => {
    fetchLogoOnce().then(item => {
      if (item?.mobile_logo) {
        setLogo(`${process.env.REACT_APP_API_URL}/storage/${item.mobile_logo}`);
      }
    }).catch(() => {});
  }, []);

  // Load LiveChatInc widget script if on qualifying origin
  useEffect(() => {
    if (window.location.origin === "https://www.chat.com") {
      window.__lc = window.__lc || {};
      window.__lc.license = 19116631;
      (function (n, t, c) {
        function i(n) { return e._h ? e._h.apply(null, n) : e._q.push(n); }
        var e = {
          _q: [], _h: null, _v: "2.0",
          on: function () { i(["on", c.call(arguments)]); },
          once: function () { i(["once", c.call(arguments)]); },
          off: function () { i(["off", c.call(arguments)]); },
          get: function () {
            if (!e._h) throw new Error("[LiveChatWidget] You can't use getters before load.");
            return i(["get", c.call(arguments)]);
          },
          call: function () { i(["call", c.call(arguments)]); },
          init: function () {
            var n = t.createElement("script");
            n.async = true; n.type = "text/javascript";
            n.src = "https://cdn.livechatinc.com/tracking.js";
            t.head.appendChild(n);
          },
        };
        !n.__lc.asyncInit && e.init();
        n.LiveChatWidget = n.LiveChatWidget || e;
      })(window, document, [].slice);
    }
  }, []);

  // Determine which chat mode to show
  useEffect(() => {
    let whatsapp = localStorage.getItem("whatsapp");
    let live_chat = localStorage.getItem("liveChat");
    setShow(live_chat !== 'null' ? 'live_chat' : 'base_chat');
    setWhatsappLink(whatsapp !== 'null' ? whatsapp : null);
  }, []);

  // Listen for custom open_chat event — [] prevents re-subscribing on every render
  useEffect(() => {
    const handler = () => handleChatClick();
    window.addEventListener('open_chat', handler);
    return () => window.removeEventListener('open_chat', handler);
  }, []);

  // ── Drag handlers ──────────────────────────────────────────

  const handleStart = (e) => {
    setDragging(true);
    setDragDistance(0);
    const event = e.type === "touchstart" ? e.touches[0] : e;
    const rect = chatRef.current.getBoundingClientRect();
    setOffset({ x: event.clientX - rect.left, y: event.clientY - rect.top });
    if (e.type === "mousedown") {
      document.addEventListener("mousemove", handleMove);
      document.addEventListener("mouseup", handleEnd);
    } else {
      document.addEventListener("touchmove", handleMove, { passive: false });
      document.addEventListener("touchend", handleEnd);
    }
  };

  const handleMove = (e) => {
    const event = e.type === "touchmove" ? e.touches[0] : e;
    e.preventDefault();
    const newX = event.clientX - offset.x;
    const newY = event.clientY - offset.y;
    const distance = Math.sqrt(Math.pow(newX - position.x, 2) + Math.pow(newY - position.y, 2));
    setDragDistance(distance);
    setPosition({ x: newX, y: newY });
  };

  const handleEnd = (e) => {
    if (dragDistance > 10) e.preventDefault();
    setDragging(false);
    document.removeEventListener("mousemove", handleMove);
    document.removeEventListener("mouseup", handleEnd);
    document.removeEventListener("touchmove", handleMove);
    document.removeEventListener("touchend", handleEnd);
  };

  // ── Chat open logic ──────────────────────────────────────────

  const handleChatClick = (e) => {
    if (e) e.preventDefault();
    if (dragDistance > 10) return;

    const remoteId = localStorage.getItem("remote_id");
    const username = localStorage.getItem("username");

    if (window.Intercom) {
      window.Intercom("show");
    } else if (whatsappLink && whatsappLink !== 'null' && whatsappLink.length > 0) {
      window.open(whatsappLink, "_blank");
    } else {
      if (window?.anw2 !== undefined) window.anw2.open();
      if (window.LiveChatWidget) {
        window.LiveChatWidget.once("ready", () => {
          if (remoteId && username) {
            window.LiveChatWidget.call("set_customer_data", { name: username, external_id: remoteId });
          }
          window.LiveChatWidget.call("maximize");
        });
      }
      if (window.Tawk_API) window.Tawk_API.maximize();
    }
  };

  if (hideChat) return null;
  if (show !== null && show !== 'live_chat' && !whatsappLink) return null;

  return (
    <>
      <style>{`[id^="anw2-launcher-container-"] [id^="anw2-launcher-"]{ display: none !important; }`}</style>
      <a href="#chat" onClick={handleChatClick}>
        <div
          ref={chatRef}
          className="chat-tongole"
          style={{
            position: "fixed",
            left: `${position.x}px`,
            top: `${position.y}px`,
            cursor: dragging ? "grabbing" : "grab",
            zIndex: 10000,
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            overflow: "hidden",
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 8px rgba(0,0,0,0.4)",
          }}
          onMouseDown={handleStart}
          onTouchStart={handleStart}
        >
          {logo && (
            <img
              src={logo}
              alt="Chat"
              style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }}
            />
          )}
        </div>
      </a>
    </>
  );
}

export default ChatTongole;
